import { LINKEDIN_INDICATORS_BY_CONTEXT_TYPE } from './indicators/linkedinIndicators';
import { LINKEDIN_RECRUITER_LITE_INDICATORS_BY_CONTEXT_TYPE } from './indicators/linkedinRecLiteIndicators';
import { LINKEDIN_RECRUITER_PRO_INDICATORS_BY_CONTEXT_TYPE } from './indicators/linkedinRecProIndicators';
import { LINKEDIN_SALES_NAVIGATOR_INDICATORS_BY_CONTEXT_TYPE } from './indicators/linkedinSalesNavIndicators';
export const getLinkedinPageListeners = context => ({
    selectors: [],
    observers: {
        experienceElement: ['.background-details'],
        experiencesCount: ['.pv-profile-section__card-heading'],
        profileSectionContainerMutate: ['.profile-detail'],
    },
    indicatorIterations: {
        numOfIterations: 10,
        millisPerIteration: 1000,
    },
    emptyStateIndicators: {
        LINKEDIN: [
            '.artdeco-empty-state',
            '.page-not-found',
            '[data-sdui-screen="com.linkedin.sdui.flagshipnav.search.SearchResultsPeople"] h2 + p',
        ],
        LINKEDIN_RECRUITER_LITE: ['.artdeco-empty-state'],
        LINKEDIN_RECRUITER_PRO: ['.artdeco-empty-state'],
        LINKEDIN_SALES_NAVIGATOR: [
            '[data-test-empty-state]',
            '[class*="_search-empty-states"]',
            '.list-is-empty',
            '.error-message',
        ],
    },
    indicators: {
        LINKEDIN: LINKEDIN_INDICATORS_BY_CONTEXT_TYPE[context],
        LINKEDIN_RECRUITER_LITE: LINKEDIN_RECRUITER_LITE_INDICATORS_BY_CONTEXT_TYPE[context],
        LINKEDIN_RECRUITER_PRO: LINKEDIN_RECRUITER_PRO_INDICATORS_BY_CONTEXT_TYPE[context],
        LINKEDIN_SALES_NAVIGATOR: LINKEDIN_SALES_NAVIGATOR_INDICATORS_BY_CONTEXT_TYPE[context],
    },
    linkedinProfilePageLoadSettings: {
        pendingElementSelector: '.pv-occludable__background', // deprecated on 12.10.2021, Contact Page - Contact hidden Sections , (experience, about, education), (Lusha Contacts)
        pendingElementsSelectors: [{ selector: '.pv-occludable__background' }],
        verifyLoadSettings: {
            numOfIterations: 80,
            millisPerIteration: 40,
        },
        scrollVolume: 5,
    },
    salesNavBulkLoadElementsSettings: {
        contactCardClass: '.search-results__result-item', // deprecated on 1.9.2021, we should wait until remove it to support old plugin versions
        readyToLoadIndicator: '.deferred-area--pending', // deprecated on 1.9.2021, we should wait until remove it to support old plugin versions
        pendingElementSelector: '.deferred-area--pending', // deprecated on 12.10.2021, Search Page - Hidden Contacts Container (Bulk Enrich)
        pendingElementsSelectors: [
            { selector: '.deferred-area--pending' },
            { selector: 'div[data-test-deferred-did-intersect]', pendingChildrenSelector: '.dummy-button-medium' },
            { selector: 'li.artdeco-list__item', pendingChildrenSelector: '.dummy-text' }, // V3 25/05/2022
        ],
        verifyLoadSettings: {
            numOfIterations: 80,
            millisPerIteration: 40,
        },
        scrollVolume: 5,
    },
    bulkRevealPendingElements: {
        linkedinSalesNavigator: {
            pendingElementsSelectors: [
                { selector: '.deferred-area--pending' },
                { selector: 'div[data-test-deferred-did-intersect]', pendingChildrenSelector: '.dummy-button-medium' },
                { selector: 'li.artdeco-list__item', pendingChildrenSelector: '.dummy-text' }, // V3 25/05/2022
            ],
            verifyLoadSettings: {
                numOfIterations: 80,
                millisPerIteration: 40,
            },
            scrollVolume: 5,
        },
        linkedinRecruiterPro: {
            pendingElementsSelectors: [{ selector: '.profile-list__occlusion-area' }],
            loadingElementSettings: {
                selector: '.artdeco-loader.ember-view',
                numOfIterations: 20,
                millisPerIteration: 100,
            },
            verifyLoadSettings: {
                numOfIterations: 80,
                millisPerIteration: 40,
            },
            scrollVolume: 5,
        },
    },
    extractIframeContent: {
        linkedin: {
            iframeSelector: '[data-testid="interop-iframe"]',
        },
    },
    purifyElements: {
        // Find images that does not contain a certain class name
        img: /<\s*img(?!.*class=["'][^"']*(pv-top-card-profile-picture__image|circle-entity-8|presence-entity__image|user-nav__profile-photo|circle-entity-4|lockup__image)[^"']*["'])[^>]*>/g,
    },
    clickOnElementsToTriggerElements: {
        linkedinSalesNavigator: {
            clickableElements: [
                {
                    selector: 'button[data-x--lead-actions-bar-overflow-menu]',
                    triggeredElement: {
                        sourceAttributeType: 'id',
                        sourceAttributeName: 'id',
                        sourceReplacePattern: {
                            search: /-trigger/g,
                            replace: '',
                        },
                        targetSelectorPrefix: '#', // refer to id
                        verifyLoadSettings: {
                            numOfIterations: 80,
                            millisPerIteration: 40,
                        },
                    },
                },
            ],
        },
    },
});
